// Track milestones and POST to the backend to fire a branded congrats email.
// Idempotent via localStorage so we don't spam the same milestone twice.
//
// NOTE: localStorage holds only non-sensitive milestone keys (`habitId:streak`
// → timestamp). No tokens or PII.

import { supabase } from './supabase';

const MILESTONES = [7, 30, 100, 365];
const STORAGE_KEY = 'mfh:milestones-sent';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const read = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
  catch { return {}; }
};
const write = (obj) => localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));

export const maybeFireMilestoneEmail = async (habitId, newStreak) => {
  if (!habitId || !newStreak) return;
  const hit = MILESTONES.find((m) => m === newStreak);
  if (!hit) return;
  const key = `${habitId}:${hit}`;
  const sent = read();
  if (sent[key]) return;
  sent[key] = Date.now();
  write(sent);
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) return;
    await fetch(`${BACKEND}/api/email/milestone`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ habit_id: habitId, streak: hit }),
    });
  } catch (err) {
    // best-effort; if it fails, milestone is already marked sent so we won't retry
    console.warn('[mfh] milestone email failed:', err);
  }
};
